import React, { useContext } from 'react';
import { Button } from '@xo-union/tk-component-buttons';
import styles from './styles.scss';
import MessageGuestsButton from './MessageGuestsButton';
import { useHistory } from 'react-router-dom';
import { previewRoute } from '../../helpers/routes';
import { TrackingContext } from '../../TrackingContext';
import useIsLiteSite from '../../helpers/useIsLiteSite';
import ShareOrPublishButton from '../SharedComponents/ShareOrPublishButton/ShareOrPublishButton';
import { FeatureToggleEnum, useFeatureTogglesContext } from '../../context/FeatureTogglesContext';

interface Props {
  className?: string;
}

const DashboardActionButtons: React.FC<Props> = ({ className = '' }) => {
  const history = useHistory();
  const isLiteSite = useIsLiteSite();
  const { track } = useContext(TrackingContext);
  const { isEnabled } = useFeatureTogglesContext();
  const shouldUseEditorRollout = isEnabled(FeatureToggleEnum.EditorRollout);

  const navigateToPreview = () => {
    track('Website Preview', { source: 'dashboard header' });

    if (shouldUseEditorRollout) {
      window.location.assign(previewRoute);
      return;
    }

    history.push(previewRoute);
  };
  return (
    <div className={`${styles.actionButtons} ${className} ${isLiteSite ? '' : styles.eipWrapper}`}>
      {isLiteSite && <MessageGuestsButton />}
      {!isLiteSite && <ShareOrPublishButton trackSource="dashboard" />}
      <div className={styles.primaryWrapper}>
        <Button
          size="lg"
          color="primary"
          onClick={navigateToPreview}
          data-testid="preview-site"
          className={styles.primaryButton}
        >
          <span className={styles.desktopCopy}>{isLiteSite ? 'Preview Site' : 'Edit website'}</span>
          <span className={styles.mobileCopy}>{isLiteSite ? 'Preview Site' : 'Edit'}</span>
        </Button>
      </div>
    </div>
  );
};

export default DashboardActionButtons;
